import type { JSX } from "react";

import { ValuationHubCoreModelRealEstateAddress } from "@/api/generatedApi";
import { CheckOutlinedIcon, CircleHalfOutlinedIcon, CircleOutlinedIcon } from "@/assets";
import { CheckFilledCircleIcon } from "@/assets/icons/CheckFilledCircleIcon";

import { CompletionStatusType, DataGroupType, DataVerificationTooltipKey } from "./dataGroupsConstants";
import { GeneralInfoTab } from "./dataRefineTabs";
import { BuildingDataTab } from "./dataRefineTabs/BuildingDataTab";
import { BuildingStandardTab } from "./dataRefineTabs/BuildingStandardTab";
import { EnergyAndPhotovoltaicTab } from "./dataRefineTabs/EnergyAndPhotovoltaicTab";
import { FinancialAndRentalInfoTab } from "./dataRefineTabs/FinancialAndRentalInfoTab";
import { ImagesTab } from "./dataRefineTabs/ImagesTab";
import { ModernizationTab } from "./dataRefineTabs/ModernizationTab";
import { PlotDataTab } from "./dataRefineTabs/PlotDataTab";

export const STATUS_ICON_MAP: Record<
  CompletionStatusType,
  { icon: JSX.Element; tooltipKey: DataVerificationTooltipKey }
> = {
  completedFull: { icon: <CheckFilledCircleIcon />, tooltipKey: "dataVerification.veryGoodTooltip" },
  completedMinimal: {
    icon: <CheckOutlinedIcon sx={{ color: "#389E0D" }} />,
    tooltipKey: "dataVerification.sufficientTooltip",
  },
  inProgress: { icon: <CircleHalfOutlinedIcon />, tooltipKey: "dataVerification.insufficientTooltip" },
  notStarted: {
    icon: <CircleOutlinedIcon sx={{ color: "#ADADAD" }} />,
    tooltipKey: "dataVerification.optionalTooltip",
  },
};

export const TAB_COMPONENT_MAP: Record<
  DataGroupType,
  React.ComponentType<{
    address?: ValuationHubCoreModelRealEstateAddress | null;
    readonly?: boolean;
    isObjectTypeReadOnly?: boolean;
    valuationId?: string | null;
    useImagesList?: boolean;
    pendingImages?: Array<{
      id: string;
      file: File;
      preview: string;
      title: string;
    }>;
    setPendingImages?: React.Dispatch<
      React.SetStateAction<
        Array<{
          id: string;
          file: File;
          preview: string;
          title: string;
        }>
      >
    >;
  }>
> = {
  generalInfo: GeneralInfoTab,
  plotData: PlotDataTab,
  buildingData: BuildingDataTab,
  energyAndPhotovoltaic: EnergyAndPhotovoltaicTab,
  buildingStandard: BuildingStandardTab,
  modernization: ModernizationTab,
  financialAndRentalInfo: FinancialAndRentalInfoTab,
  propertyImages: ImagesTab,
};
